import React, { MouseEventHandler, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../buttons/button/Button';
import { Modal } from './Modal';
import { ModalBody } from './partials/ModalBody';
import { ModalFooter } from './partials/ModalFooter';

export const ConfirmModal = ({
    title, active,
    width, height,
    onReject, onConfirm,
    className, children
}: Props) => {

    const { t } = useTranslation();

    if (!active) {
        return null;
    }

    return (
        <Modal className={className} title={title} active={active} onClose={onReject} width={width}>
            <ModalBody height={height}>
                {children}
            </ModalBody>
            <ModalFooter>
                <Button small onClick={onConfirm} title={t('commons.save')}>
                    {t('commons.save')}
                </Button>
                <Button small style='outline' onClick={onReject} title={t('commons.cancel')}>
                    {t('commons.cancel')}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

type Props = PropsWithChildren<{
    width?: number | string;
    height?: number | string;
    title: string;
    className?: string;
    active: boolean;
    onReject: MouseEventHandler;
    onConfirm: MouseEventHandler;
}>;